import React, { useEffect, useRef, useState } from "react";
import ProgressLoader from "../../ProgressLoader";
import AudioPlayer from "react-h5-audio-player";
import { ChatAudioRecorder, ChatAudioSender2 } from "../../../../../assets/images";
import "../../../../../assets/scss/audioplayer.scss";
import "react-h5-audio-player/lib/styles.css";
import { getDbInstanceName, isBlobUrl } from "../../../../../Helpers/Utility";
import { useSelector } from "react-redux";
import { getBlobUrlFromToken } from "../../../../../Helpers/Chat/ChatHelper";
import Waveform from "./AudioWaveComponent";
import { AUDIO_PLAY_EVENT } from "../../../../../Helpers/Chat/Constant";

import PropTypes from "prop-types";

const AudioComponent = (props = {}) => {
  const { messageObject = {}, uploadStatus, isSender, audioFileDownloadOnclick, mediaUrl = "", audioUrlDownloaded} = props;
  const { msgId = "", msgBody: { media: { file_url = "", audioType = "", file_key } = {} } = {} } = messageObject;
  const {mediaDownloadData, mediaDownloadingData} = useSelector((state) => state) || {};
  const h5audioPlayesr = useRef(null)
  const [isPlaying, setPlaying] = useState(false);
  const [audioUrl, setAudioUrl] = useState(mediaUrl);

  const getAudio = async () => {
   const audioBlobUrl = await getBlobUrlFromToken(file_url, getDbInstanceName("audio"), file_key, msgId);
   setAudioUrl(audioBlobUrl);
  };

  const globalStore = useSelector((state) => state);
  const {
    appOnlineStatus: { isOnline = true } = {},
    
  } = globalStore || {};
  let showProgressLoader = isOnline && (uploadStatus === 1 || uploadStatus === 0 || uploadStatus === 8 || uploadStatus === 9 || uploadStatus === 11);

  useEffect(() => {
    if (mediaUrl !== "") return setAudioUrl(mediaUrl);
    if (isBlobUrl(file_url)) return setAudioUrl(mediaUrl);
    if (mediaUrl === "" && audioUrl === "" && uploadStatus === 2) getAudio();
  }, [mediaUrl, msgId, uploadStatus]);

  useEffect(() => {
    if (audioUrl.search("blob:") !== -1 && uploadStatus ===2) {
      setAudioUrl((prevAudioUrl) => {
        audioUrlDownloaded?.(prevAudioUrl);
        return prevAudioUrl;
      });
    }
  }, [audioUrl]);

  const handleOnPlayEnd = (e) => {
    e.target.play();
    setTimeout(() => e.target.pause(), 10);
  };

  const handleOnPlay = (e = {}) => {
    window.dispatchEvent(new CustomEvent(AUDIO_PLAY_EVENT, { detail: msgId }));
    setTimeout(() => setPlaying(true), 0);
    document
      .querySelectorAll("audio")
      .forEach((element) => {
        if (element !== e.target) element.pause();
      });
  };

  useEffect(() => {
    const handleGlobalAudioPlay = (e) => {
      if (e.detail !== msgId && h5audioPlayesr.current) {
        h5audioPlayesr.current.audio.current.pause();
          setPlaying(false); 
      }
    };
    window.addEventListener(AUDIO_PLAY_EVENT, handleGlobalAudioPlay);
    return () => {
      window.removeEventListener(AUDIO_PLAY_EVENT, handleGlobalAudioPlay);
    };
  }, [msgId]);

  return (
    <>
      <div
        className={`audio-message-container ${audioType === "recording" ? "recording_main" : ""}
            ${
              uploadStatus !== 2 ||
              audioUrl === "" ||
              (msgId === mediaDownloadData?.downloadingStatus[msgId]?.downloadMediaMsgId &&
                mediaDownloadData?.downloadingStatus[msgId]?.downloading === true) ||
              (msgId === mediaDownloadingData?.downloadingData[msgId]?.msgId &&
                mediaDownloadingData?.downloadingData[msgId]?.uploadStatus === 9)
                ? "fileProgress"
                : ""
            }
            ${isPlaying ? "isPlaying" : ""}`}
      >
        <div className="audio_flex">
          {audioType !== "recording" ? (
            <i className="audio">
              <ChatAudioSender2 />
            </i>
          ) : (
            <i className="audio recording">{<ChatAudioRecorder />}</i>
          )}
          <p>{messageObject.msgBody.media.fileName}</p>
          {/* {audioType === "recording" ?(<p>Recording</p>) : (<p>{messageObject.msgBody.media.fileName}</p>)} */}
        </div>

        {audioType === "recording" && <ProgressLoader
          msgId={msgId}
          isSender={isSender}
          file_url={file_url}
          imgFileDownloadOnclick={audioFileDownloadOnclick}
          // uploadStatus={((uploadStatus === 2 && audioUrl === "") || uploadStatus === 4) ? 1 : 1}
          uploadStatus={uploadStatus}
          messageType = "audio"
          downloadEnabled = {audioUrl !== ""}
        />}
        {audioType === "recording" ? (
            <Waveform 
            audioUrl={audioUrl}
            isSender={isSender}
            messageObject={messageObject}
            showProgressLoader={showProgressLoader}
            />
          ) : (
            <AudioPlayer
              ref={h5audioPlayesr}
              src={audioUrl}
              autoPlay={false}
              autoPlayAfterSrcChange={false}
              showLoopControl={false}
              preload="none"
              showSkipControls={false}
              showJumpControls={false}
              showVolumeControl={false}
              customVolumeControls={[]}
              customAdditionalControls={[]}
              loop={false}
              onPlayError={(e) => {}}
              onEnded={(e) => handleOnPlayEnd(e)}
              onPause={() => setPlaying(false)}
              onPlay={(e) => handleOnPlay(e)}
              onSeeking={(e) => handleOnPlay(e)}
            />
        )}
        
      </div>
      {/* <div className="image-caption">
        <span></span>
      </div> */}
    </>
  );
};

export default AudioComponent;

AudioComponent.propTypes = {
  messageObject: PropTypes.object,
  uploadStatus: PropTypes.number,
  isSender: PropTypes.bool,
  audioFileDownloadOnclick: PropTypes.func,
  mediaUrl: PropTypes.string,
  audioUrlDownloaded: PropTypes.func,
};